export enum HttpCodesEnum {
	HTTP_BAD_REQUEST = 400,
	HTTP_UNAUTHORIZED_ERROR = 401,
	HTTP_FORBIDDEN_ERROR = 403,
	HTTP_NOT_FOUND = 404,
	HTTP_SERVER_ERROR = 500
}
